import React from 'react'
import Navbar from '../NavBar/navbar'
import { Row, Col } from 'antd';
import LoadingCard from './loadingCard';

export default function LoadingCards() {
    let listCards = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) =>{
        return (
        <Col flex="0.4 1 375px" style={{ marginTop: '15px' }}>
        <LoadingCard />
        </Col>
        )
      })
return (
    <div>
    <Row className="row" style={{ justifyContent: 'space-evenly' }}>
      {listCards}
  </Row>
  </div>
  )
}
